import React, { useCallback, useEffect, useState } from "react";
import { Input, Modal, Select } from "antd";
import { observer } from "mobx-react-lite";
import store from "../../../../../store/customDictionariesStore";
import { runInAction } from "mobx";
import "./index.scss";

const HistoryModal: React.FC = observer(() => {
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [history, setHistory] = useState(false);

  const handleOk = async () => {
    store.isHistoryModalVisible = false;
    return;
  };

  const handleCancel = () => {
    runInAction(() => {
      store.isHistoryModalVisible = false;
    });
  };

  useEffect(() => {
    loadInititalData();
  }, []);

  const loadInititalData = async () => {
    const result = await store.getAllItemsVersions(store.dictionaryName);
    setHistory(result.data);
    const a = 1;
    console.log(result.data);
  };

  return (
    <>
      <Modal
        title="История изменений"
        visible={store.isHistoryModalVisible}
        onOk={handleOk}
        confirmLoading={confirmLoading}
        onCancel={handleCancel}
      >
        <table>
          <thead>
            <tr>
              <th>Items</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Test 1</td>
            </tr>
            <tr>
              <td>Test 2</td>
            </tr>
          </tbody>
        </table>
      </Modal>
    </>
  );
});

export default HistoryModal;
